import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { BreadcrumbsService } from 'src/app/shared/services/breadcrumbs.service';

@Component({
  selector: 'app-selector-tipo-subida',
  templateUrl: './selector-tipo-subida.component.html',
  styleUrls: ['./selector-tipo-subida.component.css']
})
export class SelectorTipoSubidaComponent implements OnInit {

  readonly textoEnvioSimple = 'Configuración, documentos\ny envío integrados';

  @Input() moduloEnvioSimpleActivo = false;

  @Output() tipoSubidaSelected: EventEmitter<string> = new EventEmitter<string>();

  constructor(private breadcrumbsService: BreadcrumbsService) { }

  ngOnInit(): void {
  }

  selectTipoSubida(tipoSubida: string){
    if (tipoSubida.toUpperCase() == "ESTÁNDAR") {
      this.tipoSubidaSelected.emit('normal');
      this.breadcrumbsService.addBreadcrumbs('Envío estándar');
    }
    else if (tipoSubida.toUpperCase() == "MASIVA") {
      this.tipoSubidaSelected.emit('masiva');
      this.breadcrumbsService.addBreadcrumbs('Envío universal');
    }
    else if (tipoSubida.toUpperCase() == "SIMPLE") {
      this.tipoSubidaSelected.emit('simple');
    }
  }

}
